<template>
  <div>
    <Header
      :history="history"
      :data="drawerData"
      :action="action"
      @goBack="goBack"
      @toggleAction="toggleAction"
      @close="close"
    />

    <transition name="fade">
      <div v-if="isSuccess">
        <Preview
          v-if="action === 'preview'"
          :data="drawerData"
          @change="change"
          @toggleAction="toggleAction"
        />
      </div>
    </transition>

    <div
      v-if="isLoading"
      class="progress__wrapper text-xs-center py-5"
      :style="`height: ${contentHeight}px`"
    >
      <div class="progress">
        <v-progress-circular indeterminate color="accent" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { hasRole, calcContentHeight, isArray } from 'utils/functions'
import Header from './Header'
import Preview from './Preview'

export default {
  name: 'Project',
  props: {
    data: {
      type: Object,
      default: () => {}
    },

    actionType: {
      type: String,
      default: 'preview'
    },

    history: {
      type: Array,
      default: () => []
    },

    drawerType: {
      type: String,
      required: true
    }
  },
  components: {
    Header,
    Preview
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      currentStatus: null,
      drawerData: {},
      rides: [],
      contentHeight: 'none',
      action: 'preview'
    }
  },
  methods: {
    isValidArray (val) {
      return isArray(val)
    },

    hasRole (group, role) {
      return hasRole(group, role)
    },

    calcContentHeight () {
      this.contentHeight = calcContentHeight()
    },

    goBack () {
      this.$emit('goBack')
    },

    close (reload) {
      this.action = 'preview'
      this.$emit('close', reload)
    },

    change (val) {
      this.$emit('change', val)
    },

    async loadData () {
      if (!this.hasRole('billing', 'ROLE_GET_PAGINATED_ORDERS') || this.currentStatus === STATUS_IS_LOADING) {
        return
      }

      this.currentStatus = STATUS_IS_LOADING

      try {
        const company = this.selectedCompany && this.selectedCompany.id
          ? this.selectedCompany.id
          : null
        const numericalId = this.data && this.data.numericalId
          ? this.data.numericalId
          : null
        const { data: res } = await this.$apiService.getOrdersByFilter(
          { page: 0 },
          { limit: 1 },
          { company },
          { numericalId: numericalId }
        )

        this.drawerData = res && this.isValidArray(res.content) ? res.content[0] : null

        this.$emit('updateHistory', {
          drawerType: 'approvePayment',
          data: this.data
        })

        this.currentStatus = STATUS_SUCCESS
      } catch (err) {
        console.log('ERROR:', err)
        this.currentStatus = STATUS_FAILED
      }
    },

    toggleAction (action) {
      this.action = action
      if (action === 'preview') this.loadData()
    }
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        this.loadData()
      }
    },

    actionType (val) {
      val && this.toggleAction(val)
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
    this.actionType && this.toggleAction(this.actionType)
    this.loadData()
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss" scoped>
.progress__wrapper {
  position: relative;
}

.progress {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%)
}
</style>
